export const PLAN_LABELS = {
  mensual: 'Mensual',
  '6meses': '6 meses',
  '12meses': '12 meses',
  gratis: 'Gratis',
};

export const PLAN_AMOUNTS = {
  mensual: 19.99,
  '6meses': 99.99,
  '12meses': 129,
  gratis: 0,
};

export const formatPlanLabel = (plan) => {
  if (!plan) return 'Sin plan';
  return PLAN_LABELS[plan] || plan;
};

export const getPlanAmount = (plan) => PLAN_AMOUNTS[plan] ?? 0;

export const formatCurrency = (amount) =>
  new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2,
  }).format(Number(amount || 0));

export const isAdminCreatedUser = (user) => user?.registrationSource === 'admin';

export const hasPaidSubscription = (user) =>
  !isAdminCreatedUser(user) &&
  user?.plan &&
  user.plan !== 'gratis' &&
  (user?.lastPaymentStatus === 'succeeded' || user?.subscriptionStatus === 'active');
